import {useDispatch, useSelector} from "react-redux";

import {ALL_PAYMENT_VALUES, PAYMENT_CHOICES} from "shared/constants/payment";
import {applyProduct} from "shared/networking/quotes";
import BaseModal from "shared/modals/BaseModal";
import ButtonInput from "shared/components/ButtonInput";

import 'apps/QuoterApp/modals/ProductDetailsModal/styles.scss';
import {openApplyModal} from "apps/QuoterApp/reduxElements/slices/showApplyModal";


function ProductDetailsModal({show, onClose}) {
    const {selectedProduct, result} = useSelector(state => state.quoteRequest);

    const dispatch = useDispatch();

    const {id: productId, premium, premiumByPeriod, term, image, name, company, companyRatings, rateClass} =
        result.products.find(({id}) => id === selectedProduct) || {};
    const {id: quoteRequestId} = result;

    return <BaseModal className={"ProductDetailsModal"} show={show} onClose={onClose}>
        <h1 className={"ProductDetailsModal__Title"}>{name}</h1>
        <img className={"ProductDetailsModal__Logo"} src={image} alt={company}/>

        <div className={"ProductDetailsModal__Item"}>
            <span className={"Highlight"}>Company:&nbsp;</span>{company}
        </div>

        <div className={"ProductDetailsModal__Item"}>
            <span className={"Highlight"}>Company ratings:</span>
            <div className={"ProductDetailsModal__Item"}>
                {companyRatings && companyRatings.map(
                    ({name, value}) => <>
                        <span className={"Highlight"}>{name}:&nbsp;</span>{value}&nbsp;&nbsp;&nbsp;
                    </>
                )}
            </div>
        </div>


        <div className={"ProductDetailsModal__Item"}>
            <span className={"Highlight"}>Rate class:&nbsp;</span>{rateClass}
        </div>

            <div className={"ProductDetailsModal__Item"}>
                {ALL_PAYMENT_VALUES.map(
                    payment => <>
                        <span className={"Highlight"}>{PAYMENT_CHOICES[payment]} Premium:&nbsp;</span>
                        $ {premiumByPeriod && premiumByPeriod[payment].toLocaleString('en-US')}
                        <br/>
                    </>,
                )}
            </div>

        <ButtonInput
            className={"ProductDetailsModal__Apply"}
            onClick={async () => {
                onClose();

                const urlParams = new URLSearchParams(window.location.search);
                const showClientView = urlParams.get('showClientView') !== '0';
                const allowTickets = urlParams.get('allowTickets') !== '0';

                if (allowTickets) {
                    dispatch(openApplyModal());
                } else {
                    try {
                        const {applicationUrl} = await applyProduct(
                            quoteRequestId,
                            productId,
                            premium,
                            term,
                            showClientView,
                            allowTickets,
                        );
                        window.location.href = applicationUrl;
                    } catch (e) {
                        // TODO: ALERT USER
                    }
                }
            }}
        >
            Apply
        </ButtonInput>
    </BaseModal>;
}

export default ProductDetailsModal;
